<template>
  <div class="login" @keyup.enter="gopage('homeindex')">
    <div class="content-box">
      <div class="login-title">兴康智慧服务管理平台</div>
      <form style="width: 100%">
        <div class="form-group">
          <el-input
            placeholder="请输入用户名"
            class="form-control tran200"
            v-model="userName"
          >
            <i slot="prefix" class="el-input__icon el-icon-user"></i>
          </el-input>
        </div>
        <div class="form-group">
          <el-input
            type="password"
            placeholder="请输入密码"
            class="form-control tran200"
            v-model="password"
          >
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </div>
      </form>
      <el-button
        class="login-button"
        :loading="loading"
        @click="gopage('homeindex')"
        >登录
      </el-button>
    </div>
  </div>
</template>

<script>
import { userLogin } from "../api/requrestHttp"

export default {
  data() {
    return {
      userName: null,
      password: null,
      rememberPassword: false,
      loading: false,
      testcode: null,
    }
  },
  created() {
    window.sessionStorage.removeItem("initialIndex")
    window.sessionStorage.removeItem("carouseId")
  },
  methods: {
    // 编程式导航 路由跳转
    async gopage(pageName) {
      userLogin({
        loginName: this.userName,
        password: this.password,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$http
              .request({
                url: "/rbac/admin/user/info/getLoginUserInfo",
                method: "POST",
                data: {
                  id: res.data.user.id,
                },
              })
              .then((res) => {
                if (res.code != 200) return
                this.$store.commit("setMenu", res.content.menu)
                this.$router.push({
                  path: "/customerInfo",
                })
              })
            localStorage.removeItem("store")
            localStorage.token = res.data.token
            sessionStorage.setItem("tokens", res.data.token)
            sessionStorage.setItem("admin", res.data.user.admin)
            this.$store.commit("setId", res.data.user.id)
            this.$store.commit("orgId", res.data.user.orgId)
            this.$store.commit("orgName", res.data.user.orgName)
            this.$store.commit("orgAreaLevel", res.data.user.orgAreaLevel)
            this.$store.commit("orgAreaName", res.data.user.orgAreaName)
            this.$store.commit("setInfo", res.data.user)
            this.$store.commit("setNo", res.data.user.seatNo)
            // 保存当前所属党组织
            this.$store.commit("setSelectOrgId", res.data.user.partyOrgId)
            // 保存当前所属联合党委
            this.$store.commit("setSelectUnionOrgId", res.data.user.unionOrgId)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/font.css";

.login {
  position: absolute;
  width: 100%;
  height: 100vh;
  background: url(~@/assets/img/login/login-bg.png);
  background-size: 100% 100%;
  overflow: hidden;
}

.login-title {
  font-size: 38px;
  font-weight: 600;
  width: 100%;
  text-align: center;
  color: #3a74fe;
}

.content-box {
  position: absolute;
  z-index: 1000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  width: 450px;
  height: 350px;
  padding: 50px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}

.form-control.tran200 {
  margin-top: 40px;
  width: 100%;

  /deep/ .el-input__inner {
    height: 50px !important;
  }
}

.login-button {
  display: block;
  width: 100%;
  color: #fff;
  font-size: 26px;
  margin-top: 40px;
  padding: 0;
  height: 60px;
  position: relative;
  line-height: 60px;
  border: none;
  background: #3875ff;
}
</style>
